import { RefObject } from 'react';

export const outsideClickHandler = (ref: RefObject<HTMLUnknownElement>, onOutsideClick: () => void) => {
  const handleClickOutside = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      onOutsideClick();
      document.removeEventListener('click', handleClickOutside);
    }
  };

  // Bind the event listener
  document.addEventListener('click', handleClickOutside);
};
